import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";

export type InsightItem = {
  startDate: string;
  endDate: string;
  insightId: string;
  tenantName: string;
};
export type InsightsResponse = InsightItem;

interface GetInsightsParams {
  jobId: string;
}

const getInsightsForJobs = async ({
  // jobId = "184253",
  jobId,
}: GetInsightsParams): Promise<InsightsResponse[]> => {
  return apiClient
    .get(ENDPOINTS.GET_INSIGHTS_FOR_JOBS(jobId))
    .json<InsightsResponse[]>();
};

export const useGetInsightsForJobsQuery = (
  params: GetInsightsParams,
  options?: Omit<
    UseQueryOptions<InsightsResponse[], Error>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["jobInsights", params.jobId],
    queryFn: () => getInsightsForJobs(params),
    ...options,
  });
};
